import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  Service,
  ServiceFilters,
  ServiceListRequest,
  ServiceListResponse,
  ServiceNew,
  SyncAllLanguageRequest,
} from './types'
import { request } from '../../../../libs/request'

// Получение массивов статусов с помощью fetch
export const fetchArrayStatusByLang = (service: string, langs: string[]) => {
  return langs.map((lang) =>
    request({
      method: 'POST',
      url: '/translation/service/language/sync_one_language_status',
      body: {
        service: service,
        language: lang,
      },
    }),
  )
}

// Получение статуса с помощью fetch
export const fetchStatusByLang = (service: string, langs: string) =>
  request({
    method: 'POST',
    url: '/translation/service/language/sync_one_language_status',
    body: {
      service: service,
      language: langs,
    },
  })

export const serviceListMounted = createEvent<ServiceListRequest>()

export const serviceSyncMounted = createEvent()

export const syncAllLanguageMounted = createEvent<{ service: string }>()

export const getServiceList = fx<ServiceListRequest, ServiceListResponse>({
  method: 'GET',
  url: `/translation/service/language/list`,
})

export const serviceSync = fx({
  method: 'GET',
  url: `/translation/service/language/sync`,
})

export const syncAllLanguage = fx<{ service: string }, SyncAllLanguageRequest>({
  method: 'POST',
  url: `/translation/service/language/sync_all_language`,
})

export const $serviceList = restore<ServiceNew[]>(
  getServiceList.doneData.map((a) => {
    const result = a.body.items.reduce((accum, currentValue) => {
      if (!accum.find((item) => item.service === currentValue.service)) {
        accum.push({
          ...currentValue,
          lang: a.body.items
            .filter((item) => item.service === currentValue.service)
            .map((item) => item.lang),
        })
      }
      return accum
    }, [] as ServiceNew[])

    return result
  }),
  [],
)

export const $totalCountOfServiceList = restore(
  getServiceList.doneData.map((a) => a.body.total),
  0,
)

export const $listLanguagesOfServices = createStore<{
  [key: string]: string[]
} | null>(null)

export const addedDataToLanguages = createEvent<{ [key: string]: string[] }>()

$listLanguagesOfServices.on(addedDataToLanguages, (state, data) => data)

// Строит карту { service: langs[] } из сырых строк ответа
export const buildLanguagesMap = (items: Service[]) =>
  items.reduce<{ [key: string]: string[] }>((acc, { service, lang }) => {
    if (!acc[service]) {
      acc[service] = []
    }
    if (!acc[service].includes(lang)) {
      acc[service].push(lang)
    }
    return acc
  }, {})

// Загрузка всех языков сервисов без пагинации
// (для прямого захода / обновления страницы edit, когда стор ещё пуст)
export const loadAllLanguages = createEvent()

export const getAllServiceLanguages = fx<unknown, ServiceListResponse>({
  method: 'GET',
  url: '/translation/service/language/list',
})

$listLanguagesOfServices.on(getAllServiceLanguages.doneData, (_, a) =>
  buildLanguagesMap(a.body.items),
)

sample({
  clock: loadAllLanguages,
  fn: () => ({}),
  target: getAllServiceLanguages,
})

export const buildServiceWhere = (
  filters?: ServiceFilters,
): Record<string, any> => {
  const where: Record<string, any> = {}
  if (filters?.service) where['service'] = filters.service.toLowerCase()
  if (filters?.updatedAt) where['updatedAt'] = filters.updatedAt
  return where
}

sample({
  // @ts-ignore
  clock: serviceListMounted,
  fn: ({ orderBy, orderDirection, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy.includes('country')) {
      orderBy = 'client.country'
    }

    let query = {}

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    // @ts-ignore
    query['where'] = `${JSON.stringify(buildServiceWhere(filters))}`

    return {
      query,
    }
  },
  target: getServiceList,
})

sample({
  clock: serviceSyncMounted,
  fn: () => ({}),
  target: serviceSync,
})

sample({
  clock: syncAllLanguageMounted,
  fn: ({ service }) => {
    return {
      url: '/translation/service/language/sync_all_language',
      body: {
        service,
      },
    }
  },
  target: syncAllLanguage,
})

// Создаем store для хранения текущих параметров
const $serviceListParams = createStore({
  orderBy: '',
  orderDirection: '',
  filters: {},
})

// Обновляем store при каждом вызове serviceListMounted
sample({
  // @ts-ignore
  clock: serviceListMounted,
  target: $serviceListParams,
})

// Используем сохраненные параметры при запуске после syncAllLanguage
sample({
  //@ts-ignore
  clock: syncAllLanguage.doneData,
  source: $serviceListParams,
  fn: (params) => params,
  target: serviceListMounted,
})
